<ng-container *ngIf="icon || message || content; else custom">
  <u-icon *ngIf="icon" class="icon" [model]="{ type: 'img', value: { lightUrl: icon } }"></u-icon>
  <div class="message" *ngIf="message">{{ message }}</div>
  <div class="content" *ngIf="content">{{ content }}</div>
</ng-container>

<ng-template #custom>
  <ng-content></ng-content>
</ng-template>
